export default "__VITE_ASSET__70N_p7fF__"